/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/unbound-method */
import BioApi from '@/api/bio';
// import IdentityScoreDialog from '@/components/trade-dialog';
import { RouterV2Enum } from '@/router/router-names';
import { Loading } from '@/shared/utils/loading';
import { session } from '@/shared/utils/storage';
import { Dialog as DialogVant } from 'vant';
import { Vue, Component } from 'vue-property-decorator';
import { VNode } from 'vue/types/vnode';
import { CreditDataType } from '@/api/homeV2Status/types';
import { namespace } from 'vuex-class';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import { UserInfoStatus } from '@/enums/UserInfoStatus';
import { TC_OCR_NOT_CLEAR_POPUP } from '@/shared/tools/ocr/tianqi';
import { ubtSetupPageButton, ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { changeTabbarMaskStatus, skNativeContainer } from '@/api/native/container';
import isShowContainerPath from '@/shared/utils/isShowContainerPath';
import { dialogHelper } from '@/shared/utils/dialogHelper';
import { getTabIdByPath } from '@/shared/utils/getTabIdByPath/getTabIdByPath';
import { OcrProcessSourceEnum } from '@/shared/tools/ocr/enum';
import { IndentityCode, IndentityScoreEnum } from './types';

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const IdentityScoreDialog = () => import(
  /* webpackChunkName: "identity-trade-dialog" */'@/components/trade-dialog'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) as any;

const HomeStore = namespace('home');

@Component
export default class IdenttityScoreMixins extends Vue {
  @HomeStore.State creditData!: CreditDataType | null;

  // 显示弹窗判断
  private shouldUpdateIdentityPhoto = false;

  protected identityScoreBizeData: IndentityCode = {
    bizCode: 0,
    message: '',
  };

  protected get identityScorePhoto(): boolean {
    return (
      this.identityScoreBizeData
      && [
        IndentityScoreEnum.sateBizCodeTypeHua,
        IndentityScoreEnum.sateBizCodeTypeTecent,
      ].includes(this.identityScoreBizeData.bizCode)
    );
  }

  private onCloseIdentity() {
    ubtSetupPageButton(TC_OCR_NOT_CLEAR_POPUP, {
      // 按钮类型buttonType：关闭-0 / 我知道了-1
      buttonType: '0',
    });
  }

  private onConfirmIdentity() {
    ubtSetupPageButton(TC_OCR_NOT_CLEAR_POPUP, {
      // 按钮类型buttonType：关闭-0 / 我知道了-1
      buttonType: '1',
    });

    this.shouldUpdateIdentityPhoto = false;
    /** 通知关闭“身份证清晰分不足”弹窗 */
    dialogHelper.closeDialogNotify();

    /** 隐藏tabbar遮罩 */
    changeTabbarMaskStatus({
      show: false,
      duration: 100,
      tabId: getTabIdByPath(),
    });
    const { path, query = {} } = this.$route;
    /** TODO:历史逻辑-待优化，若是“提现页、资料页”，身份证清晰分不足的场景，不用再外跳到补充资料页面 */
    if (path !== RouterV2Enum.applyProduct && path !== RouterV2Enum.verifyCredit) {
      DialogVant.close();

      /** 跳转到补充资料页，进行授信主流程(其内部兼容身份证清晰度不足的场景) */
      jumpToVerifyCredit(VerifySceneEnum.CREDIT_WITH_INVALID_IDENTITY, { useReplace: true });
    } else {
      DialogVant.close();
    }
  }

  protected async updatedIdentityScore(scene?: OcrProcessSourceEnum): Promise<void> {
    try {
      const identityScoreBizeData = await BioApi.updatedIdentity({
        scene,
      });

      if (session.get('identityScoreBizeData')) {
        session.remove('identityScoreBizeData');
      }

      session.set('identityScoreBizeData', identityScoreBizeData);
      this.identityScoreBizeData = identityScoreBizeData;
    } catch (error) {
      // 避免接口失败阻塞页面渲染
    }
  }

  protected confirmShouldIdentityScore(notClearCallback?: () => void): boolean {
    this.identityScoreBizeData = session.get('identityScoreBizeData') || {
      bizCode: 0,
      message: '',
    };

    if (this.identityScorePhoto) {
      if (notClearCallback) {
        notClearCallback();
      }

      ubtSetupModuleExpose(TC_OCR_NOT_CLEAR_POPUP);
      Loading.clearAll();
      this.shouldUpdateIdentityPhoto = true;
      /** 页面已展示“身份证清晰分不足”确认弹窗，同步状态到弹窗管理 */
      dialogHelper.applyOpenDialog(true);

      /** 在首页 我的页面 才显示遮罩 */
      if (isShowContainerPath(this.$route.path)) {
        changeTabbarMaskStatus({
          show: true,
          duration: 100,
          tabId: getTabIdByPath(),
        });
      }

      return false;
    }

    return true;
  }

  // 弹窗
  protected getUpdatedIdentityPhotoDialog(): VNode {
    return (
      <IdentityScoreDialog
        tradeShow={this.shouldUpdateIdentityPhoto}
        title="身份证更新"
        content={
          this.identityScoreBizeData.message
          || '您的身份证信息已失效，请重新上传您的身份证正反面照片'
        }
        confirmText={'我知道了'}
        onClose={this.onCloseIdentity}
        onSubmit={this.onConfirmIdentity}
        ubtPage={'身份证更新弹窗显示'}
      />
    );
  }
}
